export const deleteIndexFromArray = (array, idx) => [...array.slice(0, idx), ...array.slice(idx+1)]